<template lang="pug">
	section#header
		div.wrapper
			ul(:class="{'ativo': menuAtivo}")
				li
					button(@click="$utils.scrollTo('#novosTempos', 80)") Novos Tempos
				li
					button(@click="$utils.scrollTo('#educacao', 80)") Educação de Qualidade
				li
					button(@click="$utils.scrollTo('#gradeCurricular', 80)") O que você vai aprender
				li
					button(@click="$utils.scrollTo('#certificado', 80)") Certificação
				li
					button(@click="$utils.scrollTo('#metodologia', 80)") Metodologia
				//- li
				//- 	button(@click="$utils.scrollTo('#inscricao', 80)") Matricule-se Já
			button(@click="openMenuEAD()").menu
				include ../../../assets/images/icones/menu.svg
</template>

<script>
export default {
	name: "section-header",
	data() {
		return {
			menuAtivo: false,
		}
	},
	methods: {
		openMenuEAD(){
			this.menuAtivo = !this.menuAtivo
		}
	},
}
</script>

<style lang="stylus" scoped src="./Header.styl"></style>